import { EventEmitter } from "@angular/core";

export interface PageEvent {
  pageSize: number;
  pageIndex: number;
}

export class Paginator {
  private _pageIndex: number = 0;
  private totalSize: number = 0;
  private pageEvents = new EventEmitter<PageEvent>();

  constructor(private _pageSize: number) {}

  public updateTotalSize(totalSize: number) {
    this.totalSize = totalSize;
    const newPageIndex = this.maxPageIndex;
    if (newPageIndex < this._pageIndex) {
      this._pageIndex = newPageIndex;
      this.pageEvents.next(this.currentPage);
    }
  }

  public get pageIndex(): number {
    return this._pageIndex;
  }

  public get maxPageIndex(): number {
    if (this.totalSize === 0) {
      return 0;
    }
    return Math.ceil(this.totalSize / this._pageSize) - 1;
  }

  public get pageSize(): number {
    return this._pageSize;
  }

  public get currentPage(): PageEvent {
    return {
      pageIndex: this._pageIndex,
      pageSize: this._pageSize
    };
  }

  public hasNextPage(): boolean {
    return (this._pageIndex + 1) * this._pageSize < this.totalSize;
  }

  public hasPreviousPage(): boolean {
    return this._pageIndex !== 0;
  }

  public nextPage(): boolean {
    if (!this.hasNextPage()) return false;

    this._pageIndex++;
    this.pageEvents.next({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    });
    return true;
  }

  public previousPage() {
    if (!this.hasPreviousPage()) return false;

    this._pageIndex--;
    this.pageEvents.next({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    });
    return true;
  }

  public onPageEvent(): EventEmitter<PageEvent> {
    return this.pageEvents;
  }
}
